import React from "react";
import BtnAction from "../../../boiteAOutils/BtnAction";

const MiniMap = ({viewportInfo, recenterMap}) => {
    return (
        <div className="positionDansTableau">
            <div>
                <div>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M6.0625 7.1875C6.0625 5.79297 6.80078 4.50781 8.03125 3.79688C9.23438 3.08594 10.7383 3.08594 11.9688 3.79688C13.1719 4.50781 13.9375 5.79297 13.9375 7.1875C13.9375 8.60938 13.1719 9.89453 11.9688 10.6055C10.7383 11.3164 9.23438 11.3164 8.03125 10.6055C6.80078 9.89453 6.0625 8.60938 6.0625 7.1875ZM10 5.4375C10.2188 5.4375 10.4375 5.24609 10.4375 5C10.4375 4.78125 10.2188 4.5625 10 4.5625C8.55078 4.5625 7.375 5.73828 7.375 7.1875C7.375 7.43359 7.56641 7.625 7.8125 7.625C8.03125 7.625 8.25 7.43359 8.25 7.1875C8.25 6.23047 9.01562 5.4375 10 5.4375ZM9.125 16.375V11.9453C9.39844 11.9727 9.69922 12 10 12C10.2734 12 10.5742 11.9727 10.875 11.9453V16.375C10.875 16.8672 10.4648 17.25 10 17.25C9.50781 17.25 9.125 16.8672 9.125 16.375Z"
                            fill="#F82121"/>
                    </svg>
                    Zoom : {viewportInfo.zoom.toFixed(2)}
                </div>
                <div>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M3.52344 9.39844L6.14844 6.77344C6.47656 6.41797 7.05078 6.41797 7.37891 6.77344C7.73437 7.10156 7.73437 7.67578 7.37891 8.00391L6.25781 9.125L14.2695 9.125L13.1484 8.00391C12.793 7.67578 12.793 7.10156 13.1484 6.77344C13.4766 6.41797 14.0508 6.41797 14.3789 6.77344L17.0039 9.39844C17.3594 9.72656 17.3594 10.3008 17.0039 10.6289L14.3789 13.2539C14.0508 13.6094 13.4766 13.6094 13.1484 13.2539C12.793 12.9258 12.793 12.3516 13.1484 12.0234L14.2695 10.875L6.25781 10.875L7.37891 12.0234C7.73437 12.3516 7.73437 12.9258 7.37891 13.2539C7.05078 13.6094 6.47656 13.6094 6.14844 13.2539L3.52344 10.6289C3.16797 10.3008 3.16797 9.72656 3.52344 9.39844Z"
                            fill="#70787B"/>
                    </svg>
                    X : {viewportInfo.x.toFixed(0)}
                </div>
                <div>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M10.6016 3.52344L13.2266 6.14844C13.582 6.47656 13.582 7.05078 13.2266 7.37891C12.8984 7.73438 12.3242 7.73438 11.9961 7.37891L10.875 6.25781V14.2695L11.9961 13.1484C12.3242 12.793 12.8984 12.793 13.2266 13.1484C13.582 13.4766 13.582 14.0508 13.2266 14.3789L10.6016 17.0039C10.2734 17.3594 9.69922 17.3594 9.37109 17.0039L6.74609 14.3789C6.39062 14.0508 6.39062 13.4766 6.74609 13.1484C7.07422 12.793 7.64844 12.793 7.97656 13.1484L9.125 14.2695V6.25781L7.97656 7.37891C7.64844 7.73438 7.07422 7.73438 6.74609 7.37891C6.39062 7.05078 6.39062 6.47656 6.74609 6.14844L9.37109 3.52344C9.69922 3.16797 10.2734 3.16797 10.6016 3.52344Z"
                            fill="#70787B"/>
                    </svg>
                    Y : {viewportInfo.y.toFixed(0)}
                </div>
            </div>
            <BtnAction onClick={() => {
                recenterMap()
            }}>Recentrer le tableau</BtnAction>

        </div>
    );
};

export default MiniMap;